// @flow

export const Contained: 'contained' = 'contained';
export const Outlined: 'outlined' = 'outlined';
export const Text: 'text' = 'text';
